import React from 'react';
import { useTranslation } from 'react-i18next';
import { camelCase } from 'lodash';
import classnames from '../../../core/utils/classnames.tsx';

const VoiceAgentCardContent = ({
    name,
    language,
    phoneNumber,
    enabledTools,
    titleAddon,
    children,
    className,
    ...props
}: React.ComponentPropsWithRef<'div'> & {
    name: string;
    language?: string;
    phoneNumber?: string;
    enabledTools: string[];
    titleAddon?: React.ReactNode;
}) => {
    const { t } = useTranslation('voice_agents');

    return (
        <div className={classnames('flex flex-col gap-4', className)} {...props}>
            <div className="flex flex-col gap-1 flex-1">
                <div className="flex items-center justify-between gap-2">
                    <h3 className="text-content-strong font-semibold">{name}</h3>
                    {titleAddon}
                </div>
                <div className="flex items-center gap-2 text-sm text-content-medium">
                    {language && <span className="uppercase">{language}</span>}
                    {phoneNumber && <span>{phoneNumber}</span>}
                </div>
            </div>

            {enabledTools.length > 0 && (
                <div className="flex flex-wrap gap-1.5">
                    {enabledTools.map((tool) => (
                        <span
                            key={tool}
                            className="px-2 py-0.5 text-sm rounded-full bg-surface-brand-medium-default text-content-strong"
                        >
                            {t(`tools.${camelCase(tool)}.name`, { defaultValue: tool })}
                        </span>
                    ))}
                </div>
            )}

            {children}
        </div>
    );
};

export default VoiceAgentCardContent;
